module.exports = __webpack_public_path__ + "static/media/yellow1.5be04fc1.png";